/**
 * Shared tab bar for the WhatsApp area — Templates | Interactive Messages.
 *
 * Deliberately two sibling pages under one tab strip, not one page with two
 * views: Meta-approved templates and saved List/Button messages have
 * completely different lifecycles (DRAFT→PENDING→APPROVED vs. plain CRUD — a
 * List Message can never even be a template, Meta's schema has no List
 * component). Splitting the pages keeps that distinction honest while the tab
 * strip keeps them feeling like one "WhatsApp" area, matching the renamed
 * sidebar entry.
 */
import { Box, Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

export type WhatsAppSectionTab = 'templates' | 'interactive-messages';

export default function WhatsAppSectionTabs({ active }: { active: WhatsAppSectionTab }) {
  const navigate = useNavigate();
  const location = useLocation();
  // Mounted under both /admin and / (see App.tsx) — navigate by absolute path
  // so it resolves the same from either tree, same convention WhatsAppTemplates.tsx uses.
  const pathPrefix = location.pathname.startsWith('/admin') ? '/admin' : '';

  const goTo = (tab: WhatsAppSectionTab) => {
    if (tab === active) return;
    navigate(
      tab === 'templates'
        ? `${pathPrefix}/whatsapp-templates`
        : `${pathPrefix}/whatsapp-interactive-messages`
    );
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs value={active} onChange={(_e, value) => goTo(value)}>
        <Tab value="templates" label="Templates" />
        <Tab value="interactive-messages" label="Interactive Messages" />
      </Tabs>
    </Box>
  );
}
